import { Report } from '../types/report';

const getNormalisedCardAttributes = (report: Report) => {
  const title = (report.title || '').toLowerCase();
  const description = (report.shortDescription || '').toLowerCase();
  const tags = (report.tags || []).map((tag) => tag.toLowerCase()).join(' ');

  return { description, tags, title };
};

const cardContainsSearchTerm = (card: Report, searchTerm: string) => {
  const { description, tags, title } = getNormalisedCardAttributes(card);

  return (
    title.includes(searchTerm) || description.includes(searchTerm) || tags.includes(searchTerm)
  );
};

export const filterReports = (reports: Report[], search: string) => {
  const trimmedSearch = search.trim().toLowerCase();

  if (!trimmedSearch) {
    return reports;
  }

  const searchTerms = trimmedSearch.split(' ').filter(Boolean);
  const isSingleWordSearch = searchTerms.length === 1;

  if (isSingleWordSearch) {
    const matchingIndices = reports
      .map((report, index) => (cardContainsSearchTerm(report, trimmedSearch) ? index : null))
      .filter((index): index is number => index !== null);

    return matchingIndices.map((index) => reports[index]);
  }

  const exactMatchIndices: number[] = [];
  const partialMatchIndices: number[] = [];
  for (const [index, report] of reports.entries()) {
    if (cardContainsSearchTerm(report, trimmedSearch)) {
      exactMatchIndices.push(index);
      continue;
    }

    const termsMatches = searchTerms.filter((term) => cardContainsSearchTerm(report, term));
    if (termsMatches.length > 1) {
      partialMatchIndices.push(index);
    }
  }

  return [
    ...exactMatchIndices.map((index) => reports[index]),
    ...partialMatchIndices.map((index) => reports[index]),
  ];
};
